"use client";
import { motion } from "framer-motion";
import Link from "next/link";

export default function Logo() {
  return (
    <Link href="/" aria-label="behes.dev home">
      <motion.div
        className="flex items-baseline gap-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="font-display text-2xl font-semibold tracking-tight text-[var(--text-primary)]">
          behes
        </span>
        <span className="font-mono text-sm font-medium text-[var(--brand-color)]">
          .dev
        </span>
      </motion.div>
    </Link>
  );
}
